import React from "react";
import Pluralize from "react-pluralize";
import { withCartIdParam } from "../../../utils/BrowserHelper";
import PropTypes from "prop-types";
import { LightBoxViewCartIcon } from "./vectors/AddToCartIcon";
import ContrastForegroundUtility from "../../../utils/ContrastForegroundUtility";

interface EmbedHeaderProps {
  cart: {
    photos: Array<{}>;
    sales_count?: number;
  };
  event?: {
    hasPrintProducts: boolean;
  };
}

class EmbedHeader extends React.Component<EmbedHeaderProps> {
  photosCount = () => {
    const { cart, event } = this.props;

    if (cart) {
      if (event?.hasPrintProducts) {
        if (cart.sales_count !== undefined && cart.sales_count !== null) {
          return cart.sales_count;
        }
      }

      if (cart.photos) {
        return cart.photos.length;
      }
    }
    return 0;
  };

  static contextTypes = {
    cartId: PropTypes.number,
    isEmbed: PropTypes.bool,
    pageConfiguration: PropTypes.shape({
      primaryColor: PropTypes.string,
      secondaryColor: PropTypes.string,
      accentColor: PropTypes.string
    })
  };

  render() {
    return (
      <div className="dv-embed-header">
        <a href="https://geosnapshot.com" target="_blank">
          <div className="embed-branding"></div>
        </a>

        <div className="embed-checkout">
          <span className="cart-photos">
            <Pluralize singular="photo" count={this.photosCount()} />
          </span>
          <a
            href={withCartIdParam(
              "/checkout?source=embed-nav-bar",
              this.context.cartId,
              this.context.isEmbed
            )}
            target={this.context.isEmbed ? "_blank" : ""}
            className="btn btn-primary checkout"
          >
            <LightBoxViewCartIcon
              color={ContrastForegroundUtility.fgColor(
                this.context.pageConfiguration.primaryColor
              )}
            />{" "}
            View Cart
            <span className="photos">&nbsp;({this.photosCount()})</span>
          </a>
        </div>
      </div>
    );
  }
}

export default EmbedHeader;
